import { applicationSettingSchema } from './application-setting.schema';
import { z } from 'zod/v4';

export const accountApplicationSchema = z.object({
  applicationId: z.number(),
  applicationName: z.string(),
  applicationSettings: z.array(applicationSettingSchema),
});

export type AccountApplication = z.infer<typeof accountApplicationSchema>;
